import {
  fetchDataWithLoadMore,
  updateDocument,
  deleteDocument,
  fetchDocumentById,
} from "./helperAction";
import firebase from "config/firebase";
import { toast } from "react-toastify";

const db = firebase.firestore();

export const fetchContests = ({ status, lastVisible }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        const queryOptions = [
          { method: "orderBy", args: ["createdAt", "desc"] },
          {
            method: "where",
            args: ["status", Array.isArray(status) ? "in" : "==", status],
          },
          { method: "where", args: ["contestType", "==", "Sport Contest"] },
        ];

        const response = await fetchDataWithLoadMore({
          collectionName: "contest",
          queryOptions,
          lastVisible,
        });

        dispatch({
          type: "FETCH_CONTESTS_SUCCESS",
          payload: response,
        });

        resolve(response);
      } catch (error) {
        toast.error(error.message || "Unable to fetch organizers");
        reject(error);
      }
    });
  };
};

export const approveContest = ({ id, status }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        let getContest = await db
          .collection("contest")
          .orderBy("contestNumber", "desc")
          .limit(1)
          .get();

        let contestID;
        let contestNumber;

        if (getContest.empty) {
          contestID = "SC1";
          contestNumber = 1;
        } else {
          contestNumber = parseInt(getContest.docs[0].data().contestNumber) + 1;
          contestID = `SC${contestNumber}`;
        }

        await updateDocument({
          collectionName: "contest",
          docId: id,
          updateData: { status, contestID, contestNumber },
        });

        await db.collection("school_notifications").add({
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          contestId: id,
          isRead: [],
          type: "contest",
        });

        dispatch({
          type: "UPDATE_CONTEST_STATUS_SUCCESS",
          payload: { id, status },
        });

        toast.success("Contest accepted successfully");
        resolve({ id, status });
      } catch (error) {
        toast.error(error.message || "Failed to update organizer status");
        reject(error);
      }
    });
  };
};

export const rejectContest = ({ id }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        await deleteDocument({
          collectionName: "contest",
          docId: id,
        });

        dispatch({
          type: "UPDATE_CONTEST_STATUS_SUCCESS",
          payload: { id },
        });

        toast.success("Contest rejected successfully");
        resolve({ id });
      } catch (error) {
        toast.error(error.message || "Failed to update organizer status");
        reject(error);
      }
    });
  };
};

export const fetchContestOrganizer = ({ contestId }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        const contest = await fetchDocumentById({
          collectionName: "contest",
          docId: contestId,
        });

        const organizer = await fetchDocumentById({
          collectionName: "users",
          docId: contest?.userId,
        });

        dispatch({
          type: "FETCH_CONTESTS_ORGANIZER_SUCCESS",
          payload: organizer,
        });
        resolve(organizer);
      } catch (error) {
        toast.error(error.message || "Unable to fetch contest organizer");
        reject(error);
      }
    });
  };
};

export const fetchContestDetails = ({
  collectionName,
  contestId,
  contestKey = "contestId",
  userKey = "userId",
  lastVisible = null,
}) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        const queryOptions = [
          { method: "orderBy", args: ["createdAt", "desc"] },
          { method: "where", args: [contestKey, "==", contestId] },
        ];

        let response = await fetchDataWithLoadMore({
          collectionName,
          queryOptions,
          lastVisible,
        });

        const updatedData = await Promise.all(
          response.data.map(async (item) => {
            if (!item[userKey]) return item;
            const userDoc = await fetchDocumentById({
              collectionName: "users",
              docId: item[userKey],
            });
            return {
              ...item,
              userData: userDoc,
            };
          })
        );

        response = { ...response, data: updatedData };
        dispatch({
          type: "FETCH_CONTESTS_DETAILS_SUCCESS",
          payload: response,
        });
        resolve(response);
      } catch (error) {
        toast.error(error.message || "Unable to fetch contest details");
        reject(error);
      }
    });
  };
};
